import { useEffect, useRef } from "react";
import { Calendar } from "lucide-react";

const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";
const CSS_HREF = "https://assets.calendly.com/assets/external/widget.css";

let calendlyLoader = null;
const loadCalendly = () => {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.Calendly) return Promise.resolve();
  if (calendlyLoader) return calendlyLoader;
  calendlyLoader = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CSS_HREF;
      document.head.appendChild(link);
    }
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", resolve);
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
  return calendlyLoader;
};

export const CalendlyBooking = ({ url }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!url || !containerRef.current) return;
    let cancelled = false;
    loadCalendly()
      .then(() => {
        if (cancelled || !containerRef.current || !window.Calendly) return;
        containerRef.current.innerHTML = "";
        window.Calendly.initInlineWidget({
          url,
          parentElement: containerRef.current,
          prefill: {},
          utm: {},
        });
      })
      .catch(() => {
        /* non-blocking */
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (!url) return null;

  return (
    <section data-testid="calendly-booking" className="bg-cream-2 border-t border-forest/10">
      <div className="wrap-x py-20 sm:py-24">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-gold mb-5">
            <Calendar size={22} strokeWidth={1.4} className="text-gold-dark" />
          </div>
          <p className="eyebrow text-gold-dark">Self-Serve Booking</p>
          <h2 className="font-serif text-4xl sm:text-[44px] font-medium text-forest leading-[1.1] mt-5 mb-5">
            Pick a Time That Works for You
          </h2>
          <p className="text-[14.5px] leading-[1.8] text-sage">
            Prefer to skip the back‑and‑forth? Choose a 20‑minute consultation slot from the live
            calendar below and you'll receive an instant confirmation.
          </p>
        </div>
        <div
          ref={containerRef}
          data-testid="calendly-inline-widget"
          className="bg-white border border-forest/10"
          style={{ minWidth: "320px", height: "720px" }}
        />
      </div>
    </section>
  );
};

export default CalendlyBooking;
